module.exports = __webpack_public_path__ + "img/教师.0d2a5880.png";